import * as React from "react";
import { WizardDialogTrigger } from "./WizardDialogTrigger";
import { UitkTextInput, UitkFauxInput } from "uitk-react-input";
import { useLocalization } from "@shared-ui/localization-context";
import { UitkFullscreenDialog, UitkDialogAnimationType } from "uitk-react-dialog";
import { DayName, UitkDatePickerTriggeredSelector, renderDatePicker } from "uitk-react-date-picker";
import { DatePickerDialogProps } from "../typings";
import { locKeys } from "./l10n";

export const DatePickerDialog = (props: DatePickerDialogProps) => {
  const dialogTrigger =
    props.dateType === UitkDatePickerTriggeredSelector.START
      ? WizardDialogTrigger.DATEPICKERSTART
      : WizardDialogTrigger.DATEPICKEREND;

  const datePickerProps = {
    dateType: props.dateType,
    endDate: props.endDate,
    startDate: props.startDate,
    midnightBookingOffsetHours: 4,
    numDaysBookableInAdvance: 500,
    controls: {
      dismiss: () => props.onDismiss(dialogTrigger),
      save: (start: Date, end: Date) => props.onSave(start, end, dialogTrigger),
    },
    firstDayOfWeek: DayName.SUN,
    textValues: props.textValues ? props.textValues : {},
    datePickerContent: props.datePickerContent ? props.datePickerContent : undefined,
  };

  React.useEffect(() => {
    if (props.topMessage) {
      const calendar = document.querySelector(".uitk-calendar");
      const legalDisclaimer = document.createElement("div");

      legalDisclaimer.textContent = props.topMessage;
      legalDisclaimer.className =
        "uitk-type-200 all-b-padding-six uitk-type-center all-l-padding-three all-r-padding-three all-t-padding-three";

      if (calendar) {
        calendar.appendChild(legalDisclaimer);
      }
    }
  });

  return (
    <UitkFullscreenDialog className="DatePickerDialog" dialogShow={true} animation={UitkDialogAnimationType.SLIDEUP}>
      {renderDatePicker(
        datePickerProps.dateType,
        datePickerProps.startDate,
        datePickerProps.endDate,
        datePickerProps.numDaysBookableInAdvance,
        datePickerProps.midnightBookingOffsetHours,
        {},
        datePickerProps.controls,
        datePickerProps.textValues,
        datePickerProps.firstDayOfWeek,
        datePickerProps.datePickerContent
      )}
    </UitkFullscreenDialog>
  );
};

export const DateFields = (props: {
  dateType: string;
  id: string;
  date: Date | string;
  open: (type: UitkDatePickerTriggeredSelector) => void;
  invalid: string;
  focusInput: React.Ref<HTMLButtonElement>;
}) => {
  const { formatText, formatDateString } = useLocalization();
  const isStartDate = props.dateType === "start";
  const name = isStartDate ? "startDate" : "endDate";
  const label = isStartDate ? formatText(locKeys.checkIn) : formatText(locKeys.checkOut);
  const triggeredSelector = isStartDate ? UitkDatePickerTriggeredSelector.START : UitkDatePickerTriggeredSelector.END;

  const textInputProps = {
    icon: "today",
    className: "is-hidden",
    value: typeof props.date === "string" ? props.date : props.date.toString(),
    onChange: () => null,
    invalid: props.invalid,
    id: `${props.id}-label`,
    name,
    label,
  };

  return (
    <UitkTextInput {...textInputProps}>
      <UitkFauxInput
        id={`${props.id}-btn`}
        domRef={props.focusInput}
        onClick={props.open.bind(this, triggeredSelector)}
      >
        {formatDateString(props.date, { skeleton: "MMMd" })}
      </UitkFauxInput>
    </UitkTextInput>
  );
};
